
export default {
    APP_VERSION_INFO: `/ots/api/b/v1/app/version/info`, // 验证token状态 ?appName=CALL
}
